import { Flex, Spin } from 'antd';
import { createContext, ReactNode, useCallback, useEffect, useState } from 'react';
import { API } from '../api';

interface ParcelStatusContextProps {
  statusList: any[];
}
export const ParcelStatusContext = createContext<ParcelStatusContextProps>({ statusList: [] });

export const ParcelStatusProvider = ({ children }: { children: ReactNode }) => {
  const [statusList, updateStatusList] = useState([]);
  const [loading, updateLoading] = useState(true);

  const fetchStatusList = useCallback(async () => {
    try {
      updateLoading(true);
      const { result } = await API.get({ apiVersion: 'api' })(`/settings/shipment_status/list`);
      updateStatusList(result);
    } catch (error: any) {
      console.debug(error);
    } finally {
      updateLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchStatusList();
  }, []);

  return (
    <ParcelStatusContext.Provider value={{ statusList }}>
      {loading ? (
        <Flex style={{ width: '100%', height: '100vh' }} align="center" justify="center">
          <Spin />
        </Flex>
      ) : (
        children
      )}
    </ParcelStatusContext.Provider>
  );
};
